export const appConfig = {
     baseAPIURL: process.env.VUE_APP_BaseAPIURL
}
appConfig.APILogin = appConfig.baseAPIURL + '/ir/auth/login';